import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=72bb5c46&scoped=true"
import script from "./SectionItem.vue?vue&type=script&lang=js"
export * from "./SectionItem.vue?vue&type=script&lang=js"
import style0 from "./SectionItem.vue?vue&type=style&index=0&id=72bb5c46&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bb5c46",
  null
  
)

export default component.exports